import ADUH_LOGO from "_Mobile/assets/aduh/ADUH.png";
import ITALIC_DESC from "_Mobile/assets/aduh/aduh_italic_desc.png";
import CTA from "_Mobile/assets/aduh/aduh_CTA.png";
import { Link } from 'react-router-dom';
import MobileAduhAddress from "_Mobile/components/Aduh/Address";
import FB from "_Mobile/assets/aduh/aduh_fb.png";
import TT from "_Mobile/assets/aduh/aduh_ttok.png";
import IG from "_Mobile/assets/aduh/aduh_ig.png";
import "./style.css";

const MobileAduhLanding = () => (
  <div className="Aduh MobileAduhLanding">
    <Link to="/aduh">
      <img className="logo" src={ADUH_LOGO} alt="" />
    </Link>
    <img className="italic_desc" src={ITALIC_DESC} alt="" />
    <a aria-label="Chat on WhatsApp" href="https://wa.me/60283591" target="_blank" rel="noopener noreferrer">
      <div className="CTA_wrapper">
        <img className="CTA" src={CTA} alt="" />
      </div>
    </a>
    <div className="mid-link">
      <Link to="/aduh/peralatan">
          peralatan
      </Link>
    </div>
    <div className="mid-link">
      <Link to="/aduh/harga">
          harga
      </Link>
    </div>
    <div className="mid-link">
      <Link to="/aduh/toko">
          toko
      </Link>
    </div>
    <div className="social-links">
      <a href="https://www.facebook.com/share/19eZMZY11Y/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer">
          <img src={FB} alt="fb" />
      </a>
      <a href="https://www.tiktok.com/@sotoaduh" target="_blank" rel="noopener noreferrer">
          <img src={TT} alt="tiktok" />
      </a>
      <a href="https://www.instagram.com/sotoaduh" target="_blank" rel="noopener noreferrer">
          <img src={IG} alt="ig" />
      </a>
    </div>
    <MobileAduhAddress />
  </div>
);

export default MobileAduhLanding;